import type { Period, VyDate } from '@vy/utils';
import { isNotNullOrUndefined, vyDate } from '@vy/utils';
import { duration } from '@vy/utils';

export function formatDate(date: Date | VyDate, dateFormat = 'MMM. D, YY') {
  return vyDate(date).format(dateFormat);
}

export function formatDateToDMY(date: Date | VyDate) {
  return vyDate(date).format('DD.MM.YYYY');
}

export function formatDateToMDY(date: Date | VyDate) {
  return vyDate(date).format('MMM DD, YYYY');
}

export function utcTimeFromDayjs(dayjsDate: VyDate) {
  const utcDateInMilliseconds = Date.UTC(
    dayjsDate.year(),
    dayjsDate.month(),
    dayjsDate.date(),
    dayjsDate.hour(),
    dayjsDate.minute(),
    dayjsDate.second(),
  );

  return new Date(utcDateInMilliseconds);
}
export function compareDatesDescending(firstDate: Date, secondDate: Date) {
  return new Date(secondDate).getTime() - new Date(firstDate).getTime();
}

export function compareOptionalDatesDescending(firstDate: Date | null, secondDate: Date | null) {
  if (isNotNullOrUndefined(firstDate) && isNotNullOrUndefined(secondDate)) {
    return compareDatesDescending(firstDate, secondDate);
  }

  if (isNotNullOrUndefined(firstDate)) {
    return -1;
  }

  if (isNotNullOrUndefined(secondDate)) {
    return 1;
  }

  return 0;
}

export function getCurrentDate() {
  return new Date();
}

export function formatDurationBetweenDates(startDate: VyDate | Date, endDate: VyDate | Date): string {
  const dateDiff = vyDate(endDate).diff(startDate);
  const diffDuration = duration(dateDiff);

  const hours = diffDuration.hours();
  const minutes = diffDuration.minutes();
  const days = diffDuration.days();

  const daysString = days !== 0 ? `${days} d` : '';

  return `${daysString} ${hours} h ${minutes} min ago`;
}

export function formatPeriodMonths(period: Period): string {
  const dateDiff = vyDate(period.endTime).diff(vyDate(period.startTime), 'months', true);
  const diffDuration = duration(dateDiff, 'month');

  const months = diffDuration.months() + 1;

  const monthsString = months !== 0 ? `${months} months` : '';

  return monthsString.trim();
}

export function getMinDate() {
  return new Date(-8640000000000000);
}

export function getMaxDate() {
  return new Date(8640000000000000);
}

export function toMonthStart(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function weeksToDays(weeks: number) {
  return weeks * 7;
}

export function monthsToDays(months: number) {
  return months * 30;
}
